import dayjs from "dayjs";

export enum StatusTableColumns {
  DATE = "deliveryDate",
  ACTIVITY_ORDERED = "orderedToGenerate",
  GENERATION_PENDING = "hangingOnPending",
  GENERATION_FAILED = "failedToGenerate",
  GENERATED = "successfullyGenerated",
  NEGLIGIBLE_FOR_PRINTING = "notPicked",
  PRINTING_FAILED_AT_MERCURY = "notPrint",
  PRINTED_AT_MERCURY = "printConfirmed",
  SENT_TO_MERCURY = "alreadyPicked",
  MANUAL_PRINTING_DOCUMENTS = "retainedPDF",
}

export enum ColumnTagNames {
  MER = "MER",
  USC = "USC",
  UBOX = "UBOX",
}

export enum StatusTypes {
  PRINT = "print",
  SMS = "sms",
  EHF = "ehf",
  EMAIL = "email",
}

export enum CommunicationType {
  DOCUMENT = "document",
  MESSAGE = "message",
}

export const COLUMNS = [
  {
    key: StatusTableColumns.DATE,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.DATE",
    communicationType: [CommunicationType.DOCUMENT, CommunicationType.MESSAGE],
    width: "150px",
  },
  {
    key: StatusTableColumns.ACTIVITY_ORDERED,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.ACTIVITY_ORDERED",
    communicationType: [CommunicationType.DOCUMENT, CommunicationType.MESSAGE],
    width: "155px",
  },
  {
    key: StatusTableColumns.GENERATION_PENDING,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.GENERATION_PENDING",
    communicationType: [CommunicationType.DOCUMENT],
    width: "200px",
  },
  {
    key: StatusTableColumns.GENERATION_FAILED,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.GENERATION_FAILED",
    communicationType: [CommunicationType.DOCUMENT],
    width: "180px",
  },
  {
    key: StatusTableColumns.GENERATED,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.GENERATED",
    communicationType: [CommunicationType.DOCUMENT],
    width: "150px",
  },
  {
    key: StatusTableColumns.MANUAL_PRINTING_DOCUMENTS,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.MANUAL_PRINTING_DOCUMENTS",
    communicationType: [CommunicationType.DOCUMENT],
    width: "275px",
  },
  {
    key: StatusTableColumns.NEGLIGIBLE_FOR_PRINTING,
    title:
      "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.NEGLIGIBLE_FOR_PRINTING",
    communicationType: [CommunicationType.DOCUMENT],
    width: "215px",
  },
  {
    key: StatusTableColumns.SENT_TO_MERCURY,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.SENT_TO_MERCURY",
    communicationType: [CommunicationType.DOCUMENT],
    width: "180px",
  },
  {
    key: StatusTableColumns.PRINTING_FAILED_AT_MERCURY,
    title:
      "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.PRINTING_FAILED_AT_MERCURY",
    communicationType: [CommunicationType.DOCUMENT],
    width: "220px",
  },
  {
    key: StatusTableColumns.PRINTED_AT_MERCURY,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.PRINTED_AT_MERCURY",
    communicationType: [CommunicationType.DOCUMENT],
    width: "180px",
  },
  {
    key: StatusTableColumns.GENERATION_FAILED,
    title: "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.FAILED_TO_DELIVER",
    communicationType: [CommunicationType.MESSAGE],
    width: "200px",
  },
  {
    key: StatusTableColumns.GENERATED,
    title:
      "US.USC.TEMPLATEEDITOR:DELIVERY_STATUS_DASHBOARD.SUCCESSFULLY_DELIVERED",
    communicationType: [CommunicationType.MESSAGE],
    width: "200px",
  },
];

export const INITIAL_FORM_VALUES = {
  statusType: StatusTypes.PRINT,
  dateRange: [dayjs().subtract(31, 'days'), dayjs()],
};

export const DRAWER_DEFAULT_STATE = {
  title: "",
  date: "",
  visible: false,
  width: "1000px",
};
